import * as materials from "materials/legacy/legacy-sky";
export { materials };
export default materials;
